const getAvailMatch = (clientMap, expertMap, scheduleRequests) => {
  const incomingRequests = scheduleRequests.filter(req => req !== undefined && new Date(req.startTime).getTime() > new Date().getTime());
  const matches = [];
  clientMap.forEach(client => {
    for (let i = 0; i < expertMap.length; i++) {
      if (client.start >= expertMap[i].start && client.start <= expertMap[i].end - 1000 * 60 * 60 && client.end - client.start > 1000 * 60 * 30) {
        matches.push(client.start);
      }
    }
  });
  expertMap.forEach(expert => {
    for (let i = 0; i < clientMap.length; i++) {
      if (expert.start >= clientMap[i].start && expert.start <= clientMap[i].end - 1000 * 60 * 60 && expert.end - expert.start > 1000 * 60 * 30) {
        matches.push(expert.start);
      }
    }
  });
  const result = matches.filter(match => match > new Date().getTime());

  if (incomingRequests.length) {
    const resultWithExpert = [];
    expertMap.forEach(expert => {
      for (let i = 0; i < incomingRequests.length; i++) {
        if (new Date(incomingRequests[i].startTime).getTime() >= expert.start && new Date(incomingRequests[i].endTime).getTime() - 1000 * 60 * 60 <= expert.end) {
          resultWithExpert.push(new Date(incomingRequests[i].startTime).getTime());
        }
      }
    });

    if (resultWithExpert.length) {
      return {
        time: Math.min(...resultWithExpert),
        duration: (new Date(incomingRequests[0].endTime).getTime() - new Date(incomingRequests[0].startTime).getTime()) / 1000 / 60
      };
    }
  }

  if (!!result.length) {
    return {
      time: Math.min(...result),
      duration: 60
    };
  } else {
    const matches2 = [];
    clientMap.forEach(client => {
      for (let i = 0; i < expertMap.length; i++) {
        if (client.start >= expertMap[i].start && client.start <= expertMap[i].end - 1000 * 60 * 30) {
          matches2.push(client.start);
        }
      }
    });
    expertMap.forEach(expert => {
      for (let i = 0; i < clientMap.length; i++) {
        if (expert.start >= clientMap[i].start && expert.start <= clientMap[i].end - 1000 * 60 * 30) {
          matches2.push(expert.start);
        }
      }
    });
    const result2 = matches2.filter(match => match > new Date().getTime());

    if (!!result2.length) {
      return {
        time: Math.min(...result2),
        duration: 30
      };
    } else {
      return {
        time: 0,
        duration: 60
      };
    }
  }
};

export default getAvailMatch;